import { Component } from '@angular/core';
import { LiveClassService } from '../../home/live-class.service';
import { LiveClassScheduleDto } from '../../shared/types/live-class-schedule-dto';
import { ClassType } from '../../shared/types/class-types.enum';

@Component({
  selector: 'lp2-live-class-week-schedule',
  templateUrl: './live-class-week-schedule.component.html',
  styleUrls: ['./live-class-week-schedule.component.scss']
})
export class LiveClassWeekScheduleComponent {

  public weekLiveClassSchedules: Array<LiveClassScheduleDto> = [];
  public showSchedule = false;
  public isLoading = false;
  public dayNumberArray = [];
  public carouselSettings = {
    margin: 25,
    nav: true,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        slideBy: 1
      },
      525: {
        items: 3,
        slideBy: 3
      },
      992: {
        items: 4,
        slideBy: 4
      }
    }
  };

  constructor(private liveClassService: LiveClassService) { }

  openWeekSchedule() {
    if (this.showSchedule) {
      this.showSchedule = false;
    } else {
      this.isLoading = true;
      this.liveClassService.getWeekLiveClassSchedules()
        .subscribe(schedules => {
          this.dayNumberArray = [];

          const filteredSchedules = schedules.map(schedule => ({
            ...schedule,
            liveClasses: schedule.liveClasses.filter(lc => lc.classType !== ClassType.HYBRID)
          }));

          filteredSchedules.forEach(schedule => {
            this.dayNumberArray.push(new Date(schedule.date).getDay());
          });

          this.weekLiveClassSchedules = filteredSchedules;
          this.showSchedule = true;
          this.isLoading = false;
        });
    }
  }

}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-week-schedule/live-class-week-schedule.component.ts